import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'cdn-v4';
  verMenuLateral = false;

  ngOnInit(): void {
    const self = this;
    this.reportWindowSize(self);
    window.addEventListener('resize', () => this.reportWindowSize(self));
  }

  reportWindowSize(self) {
    if(window.innerWidth <= 992) {
      self.verMenuLateral = false;
    } else {
      self.verMenuLateral = true;
    }
  }
}
